import request from "./request";
import { IRequest } from "@/shared/types/request";
import { IApplication } from "@/shared/types/applications";

export const getApplications = () =>
  request.get<never, IRequest<IApplication[]>>("/applications");

export const createApplication = (field: { title: string; bundle: string }) =>
  request.post<never, IRequest<IApplication>>("/applications", field);
